// extracted by mini-css-extract-plugin
export default {"downloadIcon":"jnj8oz9Gv48m1vuinnJ7","fadeIn":"xxqCRBt2vIYBYBeYM8kx"};